<template>
  <ValidationObserver ref="form" v-slot="{ passes, invalid, errors }">
    <form class="grid gap-x-8 gap-y-4 md:grid-cols-4" @submit.stop>
      <ValidationProvider v-slot="{ errors }" name="name" rules="required" class="md:col-span-4">
        <div>
          <bc-label tag-name="label" for="form-name" class="required">Name</bc-label>
          <bc-input
            id="form-name"
            v-model="form.name"
            :class="{ error: errors[0] }"
            type="text"
            placeholder="Full Name"
          />
          <span v-show="errors" class="block mt-1 text-sm text-red-500">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider v-slot="{ errors }" name="phone" rules="" class="md:col-span-4">
        <div>
          <label for="form-phone" class="label">Phone</label>
          <bc-input
            id="form-phone"
            v-model="form.phone"
            :class="{ error: errors[0] }"
            type="text"
            placeholder="Phone"
          />
          <span v-show="errors" class="block mt-1 text-sm text-red-500">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider v-slot="{ errors }" name="email" rules="required|email" class="md:col-span-4">
        <div>
          <label for="form-email" class="label required">Email</label>
          <bc-input
            id="form-email"
            v-model="form.email"
            :class="{ error: errors[0] }"
            type="text"
            placeholder="Email address"
          />
          <span v-show="errors" class="block mt-1 text-sm text-red-500">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider v-slot="{ errors }" name="message" rules="required" class="md:col-span-4">
        <div>
          <label for="form-message" class="label required">Message</label>
          <bc-textarea
            id="form-message"
            v-model="form.message"
            :class="{ error: errors[0] }"
            rows="4"
            placeholder="Write something..."
          />
          <span v-show="errors" class="block mt-1 text-sm text-red-500">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <div class="md:col-span-2">
        <bc-button variant="primary" :class="{'is-loading': loading }" :disabled="invalid" type="button" @click="passes(SendMessage)">
          Send Message
        </bc-button>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
export default {
  name: 'ContactForm',
  data () {
    return {
      loading: false,
      form: {}
    }
  },
  methods: {
    Reset () {
      this.form = {} // Clear input fields.
      // this.errors.clear()
    },
    SendMessage () {
      this.loading = true
      axios.post('/api/contact/send', this.form)
        .then((response) => {
          this.form = {} // Clear input fields.
          this.$nextTick(() => this.$refs.form.reset())
        })
        .catch((err) => {
          this.$refs.form.setErrors(err.response.data.errors)
          this.$dialog.alert({
            title: 'Error',
            text: err.response.data.message,
          })
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>
